/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CRSFSecReviewDesiredPolicyFieldsOutput } from './CRSFSecReviewDesiredPolicyFieldsOutput';
import {
    CRSFSecReviewDesiredPolicyFieldsOutputFromJSON,
    CRSFSecReviewDesiredPolicyFieldsOutputFromJSONTyped,
    CRSFSecReviewDesiredPolicyFieldsOutputToJSON,
} from './CRSFSecReviewDesiredPolicyFieldsOutput';
import type { CRSFSecReviewLocale } from './CRSFSecReviewLocale';
import {
    CRSFSecReviewLocaleFromJSON,
    CRSFSecReviewLocaleFromJSONTyped,
    CRSFSecReviewLocaleToJSON,
} from './CRSFSecReviewLocale';

/**
 * 
 * @export
 * @interface CRSFSecReviewSecondaryTriggerResponse
 */
export interface CRSFSecReviewSecondaryTriggerResponse {
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewSecondaryTriggerResponse
     */
    account_uuid?: string;
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewSecondaryTriggerResponse
     */
    asm_entity_id?: string;
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewSecondaryTriggerResponse
     */
    asm_external_id?: string;
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewSecondaryTriggerResponse
     */
    cobranded?: string;
    /**
     * 
     * @type {CRSFSecReviewDesiredPolicyFieldsOutput}
     * @memberof CRSFSecReviewSecondaryTriggerResponse
     */
    desired_policy_fields?: CRSFSecReviewDesiredPolicyFieldsOutput;
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewSecondaryTriggerResponse
     */
    desired_policy_uuid?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CRSFSecReviewSecondaryTriggerResponse
     */
    domains: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof CRSFSecReviewSecondaryTriggerResponse
     */
    dry_run?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CRSFSecReviewSecondaryTriggerResponse
     */
    force?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewSecondaryTriggerResponse
     */
    issue_key: string;
    /**
     * 
     * @type {CRSFSecReviewLocale}
     * @memberof CRSFSecReviewSecondaryTriggerResponse
     */
    locale?: CRSFSecReviewLocale;
    /**
     * 
     * @type {Array<string>}
     * @memberof CRSFSecReviewSecondaryTriggerResponse
     */
    new_domains_at_bind?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewSecondaryTriggerResponse
     */
    process_id: string;
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewSecondaryTriggerResponse
     */
    renewal_of_uuid?: string;
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewSecondaryTriggerResponse
     */
    request_origin?: string;
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewSecondaryTriggerResponse
     */
    retained_from_uuid?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CRSFSecReviewSecondaryTriggerResponse
     */
    scan_web_sev2_force?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CRSFSecReviewSecondaryTriggerResponse
     */
    signal_id?: number;
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewSecondaryTriggerResponse
     */
    user?: string;
}

/**
 * Check if a given object implements the CRSFSecReviewSecondaryTriggerResponse interface.
 */
export function instanceOfCRSFSecReviewSecondaryTriggerResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "domains" in value;
    isInstance = isInstance && "issue_key" in value;
    isInstance = isInstance && "process_id" in value;

    return isInstance;
}

export function CRSFSecReviewSecondaryTriggerResponseFromJSON(json: any): CRSFSecReviewSecondaryTriggerResponse {
    return CRSFSecReviewSecondaryTriggerResponseFromJSONTyped(json, false);
}

export function CRSFSecReviewSecondaryTriggerResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFSecReviewSecondaryTriggerResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'account_uuid': !exists(json, 'account_uuid') ? undefined : json['account_uuid'],
        'asm_entity_id': !exists(json, 'asm_entity_id') ? undefined : json['asm_entity_id'],
        'asm_external_id': !exists(json, 'asm_external_id') ? undefined : json['asm_external_id'],
        'cobranded': !exists(json, 'cobranded') ? undefined : json['cobranded'],
        'desired_policy_fields': !exists(json, 'desired_policy_fields') ? undefined : CRSFSecReviewDesiredPolicyFieldsOutputFromJSON(json['desired_policy_fields']),
        'desired_policy_uuid': !exists(json, 'desired_policy_uuid') ? undefined : json['desired_policy_uuid'],
        'domains': json['domains'],
        'dry_run': !exists(json, 'dry_run') ? undefined : json['dry_run'],
        'force': !exists(json, 'force') ? undefined : json['force'],
        'issue_key': json['issue_key'],
        'locale': !exists(json, 'locale') ? undefined : CRSFSecReviewLocaleFromJSON(json['locale']),
        'new_domains_at_bind': !exists(json, 'new_domains_at_bind') ? undefined : json['new_domains_at_bind'],
        'process_id': json['process_id'],
        'renewal_of_uuid': !exists(json, 'renewal_of_uuid') ? undefined : json['renewal_of_uuid'],
        'request_origin': !exists(json, 'request_origin') ? undefined : json['request_origin'],
        'retained_from_uuid': !exists(json, 'retained_from_uuid') ? undefined : json['retained_from_uuid'],
        'scan_web_sev2_force': !exists(json, 'scan_web_sev2_force') ? undefined : json['scan_web_sev2_force'],
        'signal_id': !exists(json, 'signal_id') ? undefined : json['signal_id'],
        'user': !exists(json, 'user') ? undefined : json['user'],
    };
}

export function CRSFSecReviewSecondaryTriggerResponseToJSON(value?: CRSFSecReviewSecondaryTriggerResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'account_uuid': value.account_uuid,
        'asm_entity_id': value.asm_entity_id,
        'asm_external_id': value.asm_external_id,
        'cobranded': value.cobranded,
        'desired_policy_fields': CRSFSecReviewDesiredPolicyFieldsOutputToJSON(value.desired_policy_fields),
        'desired_policy_uuid': value.desired_policy_uuid,
        'domains': value.domains,
        'dry_run': value.dry_run,
        'force': value.force,
        'issue_key': value.issue_key,
        'locale': CRSFSecReviewLocaleToJSON(value.locale),
        'new_domains_at_bind': value.new_domains_at_bind,
        'process_id': value.process_id,
        'renewal_of_uuid': value.renewal_of_uuid,
        'request_origin': value.request_origin,
        'retained_from_uuid': value.retained_from_uuid,
        'scan_web_sev2_force': value.scan_web_sev2_force,
        'signal_id': value.signal_id,
        'user': value.user,
    };
}

